import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

import useTheme from "hooks/useTheme";
import CopyIcon from "theme/icons/Copy";
import useNotification from "hooks/useNotification";
import TxDoneIcon from "theme/icons/TxDone";
import TAccountsIcon from "theme/icons/TAccounts";
import CalendarIcon from "theme/icons/Calendar";
import { format } from "date-fns";
import TransferIcon from "theme/icons/Transfer";
import CoinsIcon from "theme/icons/Coins";
import FeesIcon from "theme/icons/Fees";
import UserIconRoundIcon from "theme/icons/UserIconRound";
import AlgorandLogoIcon from "theme/icons/AlgorandLogo";
import { useSelector } from "react-redux";

const SwapTransactionSuccessModal = ({ isOpen, setIsOpen, modalInfo, navigatePage }) => {
	const { appLanguage, themeColor } = useTheme();
	const { notify } = useNotification();

	return (
		<Transition appear show={isOpen} as={Fragment}>
			<Dialog as="div" className="relative z-10" onClose={() => {}}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className={`fixed inset-0 ${themeColor?.bg} bg-opacity-30`} />
				</Transition.Child>

				<div className="fixed inset-0 overflow-y-auto">
					<div className="flex min-h-full items-center justify-center p-4 text-center">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
						>
							<Dialog.Panel className="w-full max-w-xs transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
								<div className="flex flex-col w-full items-center">
									<TxDoneIcon className={`w-10`} fill={themeColor.hex} />

									<div className="flex flex-col w-full items-center justify-center space-y-7">
										<Dialog.Title
											as="h3"
											className={`flex flex-col items-center font-medium leading-6 ${themeColor?.text} space-y-1`}
										>
											<p className={`text-lg ${themeColor?.text}`}>{appLanguage?.successfullyConverted}</p>
										</Dialog.Title>

										<div
											className={`flex flex-col w-full items-center justify-center space-y-2 py-3 rounded-lg bg-opacity-10 ${themeColor.bg}`}
										>
											<p className={`text-sm ${themeColor?.text}`}>TX #</p>

											<div className="flex items-center space-x-2">
												<p className={`text-xs font-bold italic ${themeColor?.text}`}>
													{modalInfo?.txID.slice(0, 5)}...{modalInfo?.txID.slice(-5)}
												</p>

												<CopyIcon
													className={`w-4 cursor-pointer`}
													fill={themeColor?.hex}
													onClick={() => {
														navigator.clipboard.writeText(modalInfo?.txID);
														notify("success", "Copied to clipboard");
													}}
												/>
											</div>
										</div>
									</div>
								</div>

								<div className="w-full flex mt-4 space-x-3 justify-center">
									<button
										type="button"
										className={`inline-flex justify-center rounded-lg border px-4 py-2 text-sm font-medium text-white ${themeColor?.bg} hover:shadow-lg`}
										onClick={() => navigatePage("/")}
									>
										{appLanguage?.close}
									</button>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition>
	);
};

export default SwapTransactionSuccessModal;
